// services/categoryService.js
import api from '../api';

// دریافت دسته‌های اصلی (ریشه)
export const getRootCategories = (search = '') => {
  const params = { parent_id: 'null' };
  if (search) {
    params.search = search;
  }
  return api.get('/products/categories/', { params });
};

// دریافت فرزندان یک دسته
export const getCategoryChildren = (id) => {
  // return api.get(`/products/categories/`, { params: { parent_id: categoryId } });
  return api.get(`/products/categories/${id}/children/`);
};

// دریافت اطلاعات ریز (جزئیات) یک دسته شامل attributes و predefined values
export const getCategoryDetail = (id) => {
  return api.get(`/products/categories/${id}/`);
};

// جستجوی مشخصه‌ها (برای selector)
// backend باید endpoint ای مثل /products/attributes/?search=xxx داشته باشد
export const searchAttributes = (q) => {
  return api.get('/products/attributes/', { params: { search: q } });
};

// ایجاد دسته (ارسال attributes به صورت آرایه id)
export const createCategory = (data) => {
  const hasImage = data.category_image instanceof File;

  if (hasImage) {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      if (key === 'attributes' && Array.isArray(value)) {
        value.forEach((attrId) => formData.append('attributes', Number(attrId)));
      } else {
        formData.append(key, value);
      }
    });

    return api.post(`/products/categories/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }

  const payload = { ...data };
  if (payload.attributes && Array.isArray(payload.attributes)) {
    payload.attributes = payload.attributes.map(Number);
  }

  return api.post(`/products/categories/`, payload);
};


// بروزرسانی دسته
export const updateCategory = (id, data) => {
  const hasImage = data.category_image instanceof File;

  if (hasImage) {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      if (key === 'attributes' && Array.isArray(value)) {
        value.forEach((attrId) => formData.append('attributes', Number(attrId)));
      } else {
        formData.append(key, value);
      }
    });

    return api.put(`/products/categories/${id}/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }

  // اگر عکس وجود ندارد → JSON معمولی
  const payload = { ...data };
  if (payload.attributes && Array.isArray(payload.attributes)) {
    payload.attributes = payload.attributes.map(Number);
  }

  return api.put(`/products/categories/${id}/`, payload);
};


// حذف دسته
export const deleteCategory = (id) => {
  return api.delete(`/products/categories/${id}/`);
};

// گرفتن همه برگ‌ها (برای انتخاب دسته در صفحه ساخت محصول)
export const getCategoryLeaves = () => {
  return api.get('/products/categories/leaves/');
};
